<template>
  <div class="reportproduct">
    <div class="content">
      <SelectRadio v-show="Object.keys(questions).length > 0" :radioData="questions" :Finished="Finished1"></SelectRadio>
      <SelectRadio v-show="questionId == '101'" :radioData="radioData" :Finished="Finished2"></SelectRadio>
      <ChooseProduct v-show="questionId" :Finished="productFinished"></ChooseProduct>
      <EvidenceBlock v-show="questionId" :max="9" accept="image/*" :evidenceData="evidenceData" :Finished="evidenceFinished"></EvidenceBlock>
    </div>
    <z-button-group>
      <z-button :loading="sharedData.globalLoading" :disabled="!canSubmit" type="primary" @click="submit">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import ChooseProduct from '../components/ChooseProduct'
import SelectRadio from '../components/SelectRadio'
import EvidenceBlock from '../components/EvidenceBlock'
import { newReportGetQuestion } from '@api/resourceApi'
import { Button, ButtonGroup } from '@zz-common/zz-ui'
export default {
  name: 'RouteProduct',
  components: {
    zButton: Button,
    zButtonGroup: ButtonGroup,
    SelectRadio,
    EvidenceBlock,
    ChooseProduct
  },
  inject: ['sharedData', 'globalSubmit'],
  data() {
    return {
      evidenceData: {
        title: '请填写其他证据',
        text: '如有其他证据证明对方的违规行为，请补充',
        placeholder: '请补充其他的举报原因'
      },
      chooseType: '', //勾选证据类型 1商品2私信3订单
      chooseEvidence: '', //1 商品是商品id 2 私信是私信内容 3 订单是订单id  多个用逗号分割
      questionId: '', //选择的问题id
      questionDesc: '', //选择的问题
      productIllegalReason: '', //商品违规原因文案
      pics: '', //凭证照片
      content: '', //凭证描述 多个用逗号分割
      radioData: {
        question: '请选择违规原因',
        answer: [
          {
            id: 0,
            desc: '枪支弹药、军警用品'
          },
          {
            id: 1,
            desc: '假币、流通货币、银行卡及集资类'
          },
          {
            id: 2,
            desc: '药品、口服保健品'
          },
          {
            id: 3,
            desc: '易燃易爆、危险化学品、毒品'
          },
          {
            id: 4,
            desc: '假证、假章'
          },
          {
            id: 5,
            desc: '色情暴力'
          },
          {
            id: 6,
            desc: '政治敏感'
          },
          {
            id: 7,
            desc: '涉赌及相关产业'
          }
        ]
      },
      //选择问题
      questions: {}
    }
  },
  computed: {
    canSubmit() {
      if (this.sharedData.evidenceLoading) return false
      if (this.questionId == '101') {
        return this.chooseEvidence && this.chooseType && this.questionId && this.productIllegalReason && this.content.length >= 5
      } else {
        return this.chooseEvidence && this.chooseType && this.questionId && this.content.length >= 5
      }
    }
  },
  created() {
    const searchtype = this.sharedData.firstReason.id
    console.log('看看提交参数', searchtype)
    newReportGetQuestion({ type: searchtype }).then(res => {
      this.questions = res
    })
  },
  methods: {
    Finished1(data) {
      this.questionId = data.evidence
      this.questionDesc = data.desc
    },
    Finished2(data) {
      this.productIllegalReason = data.desc
    },
    submit() {
      const params = {
        questionId: this.questionId,
        questionDesc: this.questionDesc,
        productIllegalReason: this.questionId == '101' ? this.productIllegalReason : '',
        chooseType: this.chooseType,
        chooseEvidence: this.chooseEvidence,
        content: this.content,
        pics: JSON.stringify(this.pics)
      }
      this.globalSubmit(params)
    },
    productFinished(data) {
      this.chooseType = '1'
      this.chooseEvidence = data.map(t => t.infoId).join(',')
    },
    evidenceFinished(data) {
      this.content = data.message
      this.pics = data.files.map(t => t.url)
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>